import React from "react";
import { GAevent } from "../../../../utils/googleAnalyticsHelper";
import styles from "./VariantProduct.module.scss";

const VariantProduct = ({ variantOptions, openVideoModal, setVariant }) => {
  const IMAGES = require.context("../../../../../public/product-images", true, /\.jpg$/);

  return (
    <>
      {variantOptions.map(
        (variant) =>
          variant.ImagePath && (
            <div className={styles.variantContainer} key={variant.Model}>
              <img
                className={styles.variantImage}
                src={
                  IMAGES.keys()
                    .filter((file) => file.startsWith(`./${variant.ImagePath}`))
                    .map((filePath) => `${process.env.PUBLIC_URL}/product-images${filePath.substring(1)}`)[0]
                }
                alt={variant.ProductTitle}
              />
              <div className={styles.variantDetails}>
                <p className={styles.variantTitle}>
                  {variant.ProductTitle} {variant.Model}
                </p>
                <div className={styles.btnContainer}>
                  <a
                    className={styles.btn}
                    href={variant.Link}
                    rel="noreferrer"
                    target="_blank"
                    onClick={() => GAevent("Guest-User", "click", `See More Details Button - ${variant.Model}`)}
                  >
                    See More
                  </a>
                  {variant.VideoLink && (
                    <button
                      className={styles.btn}
                      onClick={() => {
                        setVariant(variant);
                        openVideoModal();
                      }}
                    >
                      Watch Video
                    </button>
                  )}
                </div>
              </div>
            </div>
          )
      )}
    </>
  );
};

export { VariantProduct };
